module.exports = __webpack_public_path__ + "static/media/onboarding2.c805b801.svg";